import * as searchConstants from '../../search-constants.js';

function getSelectedBrochureCodes(codesArray) {
  this.$data.settings.currentSearchPrefix = searchConstants.BROCHURECODESSEARCHTERM;
  this.$data.currentBrochureCodes = codesArray.join();
}
export default getSelectedBrochureCodes;
